import React from "react";
import { STYLES, TEST_IDS, textStrings } from "../../../constants";

export const StatusIndicator = ({ isActive }) => {
  return (
    <span
      className={`px-2 fw-bold ${
        isActive ? STYLES.GREEN_COLOR : STYLES.TEXT_DANGER
      }`}
      data-testid={TEST_IDS.STATUS_INDICATOR}
    >
      {isActive ? textStrings.ACTIVE : textStrings.INACTIVE}
    </span>
  );
};
